import { motion } from "framer-motion";
import { useCopy } from "../i18n";

const EASE = [0.16, 1, 0.3, 1];

export const Services = () => {
  const copy = useCopy();
  return (
  <section id="servizi" data-testid="services-section" className="py-24 lg:py-32">
    <div className="mx-auto max-w-6xl px-6">
      <div className="mb-16 max-w-2xl">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: EASE }}
          className="mb-5 flex items-center gap-4 text-xs font-medium uppercase tracking-[0.25em] text-[#1E2A38]/70"
        >
          <span className="h-px w-10 bg-[#B89762]" />
          {copy.services.eyebrow}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, ease: EASE, delay: 0.1 }}
          className="font-serif-display text-3xl font-light tracking-tight text-[#121316] sm:text-4xl lg:text-5xl"
        >
          {copy.services.titleA}
          <em className="italic text-[#B89762]">{copy.services.titleEm}</em>
          {copy.services.titleB}
        </motion.h2>
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {copy.services.items.map((s, i) => (
          <motion.article
            key={s.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, ease: EASE, delay: i * 0.12 }}
            data-testid={`service-card-${s.n}`}
            className="group flex h-full flex-col rounded-2xl border border-[rgba(18,19,22,0.08)] bg-white p-8 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_-25px_rgba(30,42,56,0.25)]"
          >
            <span className="font-serif-display text-sm italic text-[#B89762]">({s.n})</span>
            <h3 className="mt-6 font-serif-display text-2xl font-medium text-[#121316]">{s.title}</h3>
            <p className="mt-4 flex-1 text-sm leading-relaxed text-[#525866]">{s.desc}</p>
            <div className="mt-8 flex flex-wrap gap-2">
              {s.tags.map((t) => (
                <span key={t} className="rounded-full bg-[#F4F3EF] px-3 py-1 text-xs text-[#1E2A38]/80">
                  {t}
                </span>
              ))}
            </div>
            <span className="mt-8 block h-px w-full bg-[rgba(18,19,22,0.08)] transition-colors duration-300 group-hover:bg-[#B89762]" />
          </motion.article>
        ))}
      </div>
    </div>
  </section>
  );
};

export default Services;
